// src/colors.js
const colors = {
    primary: '#219B9D',
    secondary: '#ffffff',
    text: '#333333',
    whitesmoke_background: '#25252514',
  };
  
  export default colors;
  